<template>
  <div>
    <div class="floor-class">
      <!-- tab -->
      <div class="floor-tab-box clearfix">
        <div class="floor-tab-title fl">课程排行</div>
        <div class="floor-tab-list-box fl">
          <ul class="floor-tab-list clearfix">
            <li
              @mouseover="tabMove(value.id, loop)"
              class="fl"
              :class="currentTab == value.id?'tab-active':''"
              v-for="(value,loop) in list"
              :key="loop"
            >{{value.name}}</li>
          </ul>
        </div>
        <div class="floor-tab-more fr" @click="moreCourses(index)">更多</div>
      </div>
      <!-- list -->
      <div class="floor-list clearfix">
        <!-- <div class="floor-list-left fl clearfix">
          
        </div> -->
        <div class="floor-list-right fr">
          <div class="floor-list-box clearfix">
            <div
              class="special-item fl"
              @click="goDetail(value)"
              v-for="(value, loop) in courseList"
              :class="loop  == 0?'':'special-item-mr'"
              :key="loop"
            >
              <img
                class="special-item-img"
                v-if="value.course.img_thumb"
                :src="value.course.img_thumb"
                alt
              />
              <template v-else>
                <img
                  class="special-item-img"
                  src="@/assets/images/iedu/provider1.png"
                  v-if="value.provider == 1"
                  alt
                />
                <img
                  class="special-item-img"
                  src="@/assets/images/iedu/provider2.png"
                  v-else-if="value.provider == 2"
                  alt
                />
                <img
                  class="special-item-img"
                  src="@/assets/images/iedu/provider3.png"
                  v-else-if="value.provider == 3"
                  alt
                />
                <img
                  class="special-item-img"
                  src="@/assets/images/iedu/provider4.png"
                  v-else-if="value.provider == 4"
                  alt
                />
                <img class="special-item-img" src="@/assets/images/iedu/provider1.png" v-else alt />
              </template>

              <div class="special-text-box">
                <p class="special-text-name">
                  <span>{{value.course.title}}</span>
                </p>
                <div class="count-box clearfix">
                  <!-- <img class="count-icon fl" :src="imgPath.home_count" />
                  <span class="num fl">{{value.productSales}}</span> -->
                  <span class="orig-price">¥{{value.course.price_orig}}</span>
                  <span
                    class="price fr"
                    v-if="value.course.price_display  && value.course.price_display != 0.00"
                  >{{value.course.price_display}}</span>
                  <span class="price fr" v-else>免费</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imgPath from "@/common/img-path";
import Vue from "vue";
import {
  getContentByAppId,
  getProductListByCateId_2,
  getHomeCourseList,
  getHomeCourseCat
} from "@/servers/api";
export default {
  data() {
    return {
      imgPath: imgPath,
      tabActive: [],
      currentTab: 0,
      currentFloor: 0,
      list: [],
      courseList: []
    };
  },
  created() {
    // this.getContentByAppId()
    getHomeCourseCat({
      status: 1
    }).then(res => {
      this.list = res.data;
      this.currentTab = res.data[0].id,
      getHomeCourseList({
        cat_home_list: res.data[0].id,
        o: "seq"
      }).then(res => {
        if (res.errcode == 0) {
          this.courseList = res.data;
          // this.bookAllList[this.active] = res.data
        }
      });
    });
  },
  methods: {
    async tabMove(id, loop) {
      this.currentTab = id;
      getHomeCourseList({
        o: "seq",
        status: 1,
        cat_home_list: id
      }).then(res => {
        this.courseList = res.data;
      });
    },
    async getContentByAppId() {
      const res = await getContentByAppId();
      if (res.code == 0) {
        let list = [];
        list = res.data;
        list.map(async item => {
          item.courseList = [];
          if (
            item.childrenContentType &&
            item.childrenContentType[0] &&
            item.childrenContentType[0].ext1
          ) {
            const params = {
              productCate_2: item.childrenContentType[0].ext1
            };
            const result = await getProductListByCateId_2(params);

            if (result.code == 0) {
              if (result.data && result.data) {
                item.courseList = result.data.slice(0, 8);
              }
            }
          }
        });

        this.list = list;
        console.log(this.list);
      }
    },
    goDetail(item) {
      // window.location.href = item.course.url_detail;
      window.open(item.course.url_detail);
      // this.$router.push({
      //     path: '/course/detail',
      //     query: { id: item.id }
      // });
    },
    moreCourses(index) {
      window.open("/w/course");
      // window.open(
      //   "#/specialCourse?pid=" +
      //     this.list[index].masterContentType.ext1 +
      //     "&id=" +
      //     this.list[index].childrenContentType[this.currentTab].ext1
      // );
    }
  },
  props: {
    title: {
      type: String,
      required: false
    }
  }
};
</script>

<style lang="less" scoped>
.floor-class {
  width: 1200px;
  // tab
  .floor-tab-box {
    margin-top: 50px;
    border-bottom: 1px solid #fbc51d;
    // title
    .floor-tab-title {
      font-size: 24px;
      color: #333;
      line-height: 24px;
      padding-left: 10px;
      border-left: 4px solid #FFDB6A;
      margin-top: 5px;
    }
    // list
    .floor-tab-list-box {
      margin-left: 43px;
      max-width: 73%;
      // border-bottom: 1px solid #b4eafa;
      .floor-tab-list {
        overflow: hidden;
        height: 37px;
        position: relative;
        z-index: 1;
        bottom: -2px;
        li {
          padding: 0 15px;
          font-size: 14px;
          cursor: pointer;
           height: 26px;
          line-height: 26px;
        }
        .tab-active {
          background: #fbc51d;
          border-radius: 10px;
          color: #303030;
          height: 26px;
          line-height: 26px;
        }
      }
    }
    // more
    .floor-tab-more {
      background: #fbc51d;
      border-radius: 10px;
      color: #303030;
      height: 26px;
      line-height: 26px;
      padding: 0 15px;
      font-size: 14px;
      cursor: pointer;
    }
  }
  // list
  .floor-list {
    margin-top: 30px;
    .floor-list-left {
      width: 224px;
      p {
        width: 100%;
        height: 456px;
        overflow: hidden;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        // margin-bottom: 24px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .floor-list-right {
      .floor-list-box {
        width: 100%;
        .special-item-mr {
          margin-left: 14px;
        }
        .special-item {
          &:hover {
            box-shadow: 0px 16px 16px -12px #cdd0d2;
            transform: translateY(-7px);
          }
          width: 226px;
          // height:262px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(238, 238, 238, 1);
          margin-bottom: 10px;
          cursor: pointer;
          .special-item-img {
            width: 226px;
            height: 134px;
          }
          .special-text-box {
            padding: 5px;
            .special-text-name {
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              font-size: 14px;
              margin-bottom: 15px;
              // height: 40px;
              width: 90%;
              margin: 0 auto 15px;
              overflow: hidden;
              text-overflow: ellipsis;
              /* 将对象作为弹性伸缩盒子模型显示  */
              display: -webkit-box;
              /* 一个块元素显示的文本的行数 */
              -webkit-line-clamp: 2;
              /* 设置或检索伸缩盒对象的子元素的排列方式 */
              -webkit-box-orient: vertical;
              img {
                width: 16px;
                height: 16px;
                display: inline-block;
                margin-right: 10px;
              }
            }
            .count-box {
              .count-icon {
                margin-right: 6px;
                width: 13px;
                height: 15px;
              }
              .num {
                opacity: 1;
                line-height: 14px;
                letter-spacing: 1px;
                white-space: nowrap;
                color: #999999;
                font-family: Helvetica;
                font-size: 12px;
              }
              .price {
                opacity: 1;
                line-height: 19px;
                white-space: nowrap;
                color: #ec493b;
                font-family: Helvetica;
                font-size: 16px;
                margin-right: 10px;
              }
              .orig-price {
                float: right;
                opacity: 1;
                text-decoration: line-through;
                line-height: 19px;
                white-space: nowrap;
                color: #999;
                font-family: Helvetica;
                font-size: 14px;
                // margin-right: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>